import { CloseIcon, IconFrame, InfoIcon } from '@element/icons';
import { Backdrop } from '@material-ui/core';
import PostCarePage from '@template/postCarePage';
import { formatTimeTo12Hr, formatToDateFormat, getTofixValue } from '@util/utils';
import { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';

const OrderDetailModel = ({ orderData, openModal, handleClose }) => {
    const store = useSelector((state: any) => state);
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const languageData: any = store.languageKeywords
    const [postCarePopup, setPostCarePopup] = useState<{ open: boolean, serviceId: string, serviceName: string }>({ open: false, serviceId: '', serviceName: '' });

    return (
        <Fragment>
            <Backdrop
                className="backdrop-modal-wrapper"
                open={openModal ? true : false}
            >
                <div className="backdrop-modal-content" style={{ height: openModal ? 'auto' : '0px' }}>
                    <div className="heading" >{languageData["Order Details"] ? languageData["Order Details"] : "Order Details"}</div>
                    <div className="modal-close" onClick={handleClose}><IconFrame><CloseIcon /></IconFrame></div>
                    <div className='pricing-details-wrap order-history-wrap'>
                        <div className='heading order-heading-wrap'>
                            {Boolean(orderData?.orderId) && <div className='order-id'>{languageData["Order No"] ? languageData["Order No"] : "Order No"}: {orderData?.orderId}</div>}
                            <div>
                                <span className="right-align">
                                    Date: {formatToDateFormat(orderData.orderDay, configData.dateFormat)} {formatTimeTo12Hr(orderData.orderTime)}
                                </span>
                            </div>
                        </div>
                        {(() => {
                            const items = orderData?.products || [];
                            const services = items.filter((item: any) => item?.type?.toLowerCase() === 'service' || orderData?.type?.toLowerCase() === 'appointment');
                            const products = items.filter((item: any) => !(item?.type?.toLowerCase() === 'service' || orderData?.type?.toLowerCase() === 'appointment'));
                            return (
                                <>
                                    {services.length > 0 && (
                                        <>
                                            <div className='heading'>{languageData["Services"] ? languageData["Services"] : "Services"}</div>
                                            {services.map((item: any, idx: number) => (
                                                <div className='service-item' key={`service-${idx}`}>
                                                    <div
                                                        className="service-name-wrap"
                                                        style={{
                                                            cursor: (item.id && configData?.storeConfig?.basicConfig?.postCare) ? 'pointer' : 'default',
                                                            color: (item.id && configData?.storeConfig?.basicConfig?.postCare) ? '#3f51b5' : 'inherit',
                                                            fontWeight: 500
                                                        }}
                                                        onClick={(e) => {
                                                            if (item.id && configData?.storeConfig?.basicConfig?.postCare) {
                                                                e.stopPropagation();
                                                                setPostCarePopup({ open: true, serviceId: item.id, serviceName: item.name });
                                                            }
                                                        }}
                                                    >
                                                        <span>{item.name}</span>
                                                        {(item.id && configData?.storeConfig?.basicConfig?.postCare) && (
                                                            <span title="Click to view Post Care" style={{ display: 'flex' }}>
                                                                <InfoIcon style={{ fontSize: '14px', color: '#3f51b5' }} />
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className='right-align'>{configData.currencySymbol} {getTofixValue(item.billingPrice)}</div>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                    {products.length > 0 && (
                                        <>
                                            <div className='heading'>{languageData["Products"] ? languageData["Products"] : "Products"}</div>
                                            {products.map((item: any, idx: number) => (
                                                <div className='service-item' key={`product-${idx}`}>
                                                    <div className="service-name-wrap" style={{ fontWeight: 500 }}>
                                                        <span>{item.name}</span>
                                                    </div>
                                                    <div className='right-align'>{configData.currencySymbol} {getTofixValue(item.billingPrice)}</div>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </>
                            );
                        })()}
                        <span className="right-align">Total: {configData.currencySymbol} {getTofixValue(orderData.total)}</span>
                    </div>
                </div>
            </Backdrop>
            
            <Backdrop className="backdrop-modal-wrapper ordrer-backdrop-modal-wrapper" open={postCarePopup.open} style={{ zIndex: 1400 }}>
                {postCarePopup.open && (
                    <div className="backdrop-modal-content" style={{ height: '100vh' }}>
                        <div className="heading">Post-Care - {postCarePopup.serviceName}</div>
                        <div className="modal-close" onClick={() => setPostCarePopup({ open: false, serviceId: '', serviceName: '' })}>
                            <IconFrame><CloseIcon /></IconFrame>
                        </div>
                        <div className="pricing-details-wrap" style={{ height: 'calc(100vh - 60px)', overflowY: 'auto' }}>
                            <PostCarePage isPopup={true} propServiceId={postCarePopup.serviceId} propServiceName={postCarePopup.serviceName} onClose={() => setPostCarePopup({ open: false, serviceId: '', serviceName: '' })} />
                        </div>
                    </div>
                )}
            </Backdrop>
        </Fragment>
    )
}

export default OrderDetailModel